import type { Colors, DefaultTheme } from 'styled-components';
import { lightColors, mapLightTheme } from './LightTheme';

const lightBitGoColors: Colors = {
  primary: {
    lighten: '#2155f0',
    default: '#0e3fd0',
    dim: 'rgba(14,63,208,0.4)',
    mute: 'rgba(14,63,208,0.1)',
  },
  gray: {
    '100': '#1d1d28',
    '000': '#e6e6e7',
    '010': '#f2f2f3',
    main: '#ffffff',
    '020': '#fafafa',
    '030': '#ebebeb',
    '040': '#dbdbdd',
    '050': '#d2d2d4',
    '060': '#c8c8ca',
    '070': '#bbbbbe',
    '080': '#9b9b9f',
    '090': '#696970',
  },
  green: {
    lighten: '#45903c',
    default: '#346c2d',
    dim: 'rgba(52,108,45,0.4)',
    mute: 'rgba(52,108,45,0.1)',
  },
  red: {
    lighten: '#b91a35',
    default: '#8c1428',
    dim: 'rgba(140,20,40,0.4)',
    mute: 'rgba(140,20,40,0.1)',
  },
  yellow: {
    lighten: '#f1d58b',
    default: '#ebc55e',
    dim: 'rgba(235,197,94,0.4)',
    mute: 'rgba(235,197,94,0.1)',
  },
  orange: {
    lighten: '#f79c5b',
    default: '#f47f2b',
    dim: 'rgba(244,127,43,0.4)',
    mute: 'rgba(244,127,43,0.1)',
  },
  blue: {
    lighten: '#5fa2e7',
    default: '#3388E0',
    dim: 'rgba(51,136,224,0.4)',
    mute: 'rgba(51,136,224,0.1)',
  },
  purple: lightColors.purple,
  white: lightColors.white,
  black: {
    default: '#0b0b10',
    dim: 'rgba(11,11,16,0.4)',
    mute: 'rgba(11,11,16,0.1)',
  },
};

export const LightBitGoTheme: DefaultTheme = mapLightTheme(lightBitGoColors, {
  name: 'LightBGo',
});
